import { axios } from '@/services/axios';

const getAllNumbersList = async (
    currentScope,
    currentWholesaler,
    currentPartner,
    currentCompany,
) => {
    const tableFetch = () => {
        switch (currentScope) {
            case 80:
                return '/numbers/summary';
            case 60:
                return `/numbers/summary?WholesalerID=${currentWholesaler}`;
            case 40:
                return `/partner/${currentPartner}/numbers/summary`;
            default:
                return `/company/${currentCompany}/numbers/summary`;
        }
    };

    const res = await axios.get(tableFetch());

    return res.data;
};

export default getAllNumbersList;
